import { Link } from "react-router-dom";
import type { Webtoon } from "@/mocks/webtoons";
import { getCategory } from "@/mocks/categories";

interface Props {
  item: Webtoon;
}

export default function WebtoonCard({ item }: Props) {
  const cat = getCategory(item.category);
  return (
    <Link
      to={`/webtoon/${item.slug}`}
      className="group flex w-full flex-col overflow-hidden rounded-2xl border border-background-200/70 bg-background-100 transition-all duration-300 hover:-translate-y-1 hover:border-primary-200"
    >
      <div className="relative aspect-[3/4] w-full overflow-hidden">
        <img
          src={item.cover}
          alt={`${item.title} 免费韩漫封面`}
          title={`${item.title} 人气推荐`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2.5 top-2.5 flex items-center gap-1 rounded-full bg-foreground-950/75 px-2.5 py-1 text-xs font-medium text-background-50 backdrop-blur">
          <i className="ri-star-fill text-accent-400"></i>
          {item.rating.toFixed(1)}
        </span>
        <span
          className={`absolute right-2.5 top-2.5 rounded-full px-2.5 py-1 text-xs font-medium text-background-50 ${cat.color}`}
        >
          {cat.name}
        </span>
        <span className="absolute bottom-2.5 right-2.5 flex items-center gap-1 rounded-full bg-background-950/60 px-2 py-0.5 text-xs text-background-50 backdrop-blur">
          <i className="ri-eye-line"></i>
          {item.views}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-3.5">
        <h3 className="truncate text-base font-bold text-foreground-950">{item.title}</h3>
        <p className="mt-1 line-clamp-2 text-xs leading-relaxed text-foreground-600">
          {item.shortDesc}
        </p>
        <div className="mt-2.5 flex flex-wrap items-center gap-1.5">
          <span className="flex items-center gap-1 rounded-full bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900">
            <i className="ri-flag-2-fill"></i>
            {item.status}
          </span>
          <span className="flex items-center gap-1 rounded-full bg-background-200 px-2 py-0.5 text-xs text-foreground-700">
            <i className="ri-book-open-line"></i>
            {item.episode}话
          </span>
        </div>
      </div>
    </Link>
  );
}